InlineVariations = window.InlineVariations ?= {}
InlineVariations.Collections ?= {}
InlineVariations.Collections.Options = require './collections/options'
InlineVariations.Collections.Traits = require './collections/traits'
InlineVariations.Views.Main = require './views/main'

_scrollToBuyButton = ->
  return unless $('#purchase-cluster .buy.fixed, .header-row-sticked, .header-row-sticky').length
  $('body, html').animate scrollTop: $('.main').position().top - 100, 500

_scrollToTouchInlineVariation = ->
  $inlineVariationContainer = $('#inline-variations-container')
  return unless $inlineVariationContainer.length
  $('body, html').animate scrollTop: $inlineVariationContainer.position().top - $(window).height()/5, 500

InlineVariations.init = ({buyButton, deliveryEstimates, inlineVariations, offer, stickyHeader}, done) ->
  return done() unless inlineVariations?.options?.length and inlineVariations.traits?.length

  {dealOptionUuid, dealUuid, isResponsive, isTouch, mappings, options, preSelectTraits, traits} = inlineVariations
  {carouselViews, dealMedia} = DealCarousel if DealCarousel?
  isCart = (isTouch and buyButton?.cartIcon) or (!isTouch and payload?.cartStatus)

  options = new InlineVariations.Collections.Options options
  traits = new InlineVariations.Collections.Traits traits, {isTouch}

  if isTouch
    touchBuyButton = if isResponsive then ResponsiveBuyButton else TouchBuyButton
    touchBuyButton.eventBus.board('buy_button_clicked',  =>
      return if @main.variationsSelected()

      @main.showErrorMessages()
      _scrollToTouchInlineVariation()

      stopTheBus: true
    )(-300)
  else
    BuyButton.eventBus.board 'buy_button_clicked', =>
      return if BuyButton.view.variationsSelected

      @main.showErrorMessages()
      _scrollToBuyButton() if stickyHeader
      BuyButton.view.enableBuyButton()

      stopTheBus: true

  $ =>
    @main = new InlineVariations.Views.Main {carouselViews, dealMedia, dealOptionUuid, dealUuid, deliveryEstimates, isCart, isTouch, mappings, offer, options, preSelectTraits, traits, _scrollToTouchInlineVariation}
    traits.view = @main

    if options?[0]?.hideOriginalPriceAndDiscount
      $('.deal-discount').hide()
      $('.price-and-value .discount-value').html('')

    $(document.body).on 'carouselUpdate', (e, {image}) =>
      @main.updateInlineVariationSelections image

    done()

module.exports = InlineVariations
